import { render } from "./CustomCertificate.vue?vue&type=template&id=46cb307f&scoped=true"
import script from "./CustomCertificate.vue?vue&type=script&lang=js"
export * from "./CustomCertificate.vue?vue&type=script&lang=js"

import "./CustomCertificate.vue?vue&type=style&index=0&id=46cb307f&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46cb307f"]])

export default __exports__